import { getId } from 'assets/utils'
import { addressApi } from './axiosClient'

export default {
  loadAverage: (userList, fromDate, toDate) => {
    const userId = getId()

    return addressApi.get(`avg-points/${userId.sub}`, {
      params: {
        userIds: userList.join(','),
        fromDate,
        toDate,
      },
    })
  },
  loadAverageTour: (userList, fromDate, toDate, tour) => {
    const userId = getId()

    return addressApi.get(`avg-points/${userId.sub}/tours/${tour}`, {
      params: {
        userIds: userList.join(','),
        fromDate,
        toDate,
      },
    })
  },
}
